import React, { Component } from 'react'
import Button from 'components/button/button'

import {
	restoreTasks,
	restoreProject,
	openModal
} from 'state/actions'

import {
	getCurrentAccount
} from 'state/selectors'

import { withRouter } from 'react-router'
import { connect } from 'react-redux'

import {
	hasReachedProjectQuota
} from 'utils'

import { some } from 'lodash'

class ModalRestore extends Component {
	item = {}
	state = {
		checkOptionStatus: false,
	}
	
	isOverQuota = false

	UNSAFE_componentWillMount = _ => {
		const {
			dataType,
			data,
			accountData,
			allProjects,
			openModal
		} = this.props
		
		if(dataType === 'project'){
			this.isOverQuota = hasReachedProjectQuota(accountData, allProjects)	

			if(this.isOverQuota){
				openModal('pricing','pricing', {
					feature: 'projects'
				})
			}
		}

		switch (dataType) {
			case 'task':
			case 'milestone':
			case 'project':
				this.item = data.data
				break
		}
	}

	doAction = _ => {
		const {
			dataType,
			allMilestones,
			restoreTasks,
			allTasks,
			allFolders,
			restoreProject,
			accountData
		} = this.props

		if(this.isOverQuota){
			return 
		}

		if(dataType == 'project'){
			const project = this.item

			const folder = allFolders[project.folder_id]

			let forcedFolder = null

			if(!folder || folder.deleted_at || !folder.name){
				some(allFolders, folder => {
					if(folder.is_root && folder.account_id == accountData.id){
						forcedFolder = folder
						return true
					}
				})
			}

			restoreProject(project, forcedFolder)
		}else{
			const tasksToRestore = []
			let milestone = null
			
			if(dataType == 'milestone'){
				milestone = this.item

				milestone.archivedTasks && milestone.archivedTasks.forEach(taskId => {
					const taskObject = allTasks[taskId]

					if(taskObject){
						tasksToRestore.push(taskObject)
					}
				})
			}else{
				milestone = allMilestones[this.item.milestone_id]

				tasksToRestore.push(this.item)
			}

			restoreTasks(tasksToRestore, milestone)
		}
        
        this.successCallback()
	}

	successCallback = _ => {
		const {
			setLoading,
			closeCallback
		} = this.props

		setLoading(false)
		closeCallback()
	}

	render() {
		const {
			allProjects,
			allMilestones,
			dataType,
			closeCallback
		} = this.props
		
		let parentObject = null

        const object = this.item
        
        let objectName = object.name

		// this is done twice cause we want milestone and task to use the second switch's default case
		switch (dataType) {
			case 'milestone':
				parentObject = allProjects[object.project_id]
				break
			case 'task':
				parentObject = allMilestones[object.milestone_id]
				break
		}

		if(object.name){
			objectName = '"' + object.name + '"'
		}

		return (
			<div>
				<div className={'modal-task borders'}>
					{ objectName ?
							<h3>
								{objectName}
							</h3>
					: null }
					{ parentObject &&
						<span>
							from {parentObject.name}
						</span>
					}
				</div>
				<Button 
					size={'big'} 
					level={'high'} 
					callback={this.doAction} 
					label={'Yep'} 
					icon={'check'} 
				/>
				<Button 
					size={'big'} 
					level={'low'} 
					callback={closeCallback} 
					label={'Cancel'} 
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		allMilestones: state.account.entities.milestones,
		allProjects: state.account.entities.projects,
		allTasks: state.account.entities.tasks,
		allFolders: state.account.entities.folders,
		accountData: getCurrentAccount(state),
	}
}

export default withRouter(connect(mapStateToProps, {
	restoreTasks,
	restoreProject,
	openModal
})(ModalRestore))